module.exports = __webpack_public_path__ + "img/darkgrey-background.9802f9f1.jpg";